<ng-container *transloco="let t">
    <div class="mfa-login-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div
                    class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()"
                    [class.component-dark-theme]="themeService.isDark()"
                    [class.rtl-enabled]="themeService.isRTLEnabled()"
                >
                    <div class="title text-center">
                        <h3>{{t('welcome')}} ALTAIR</h3>
                        <p class="ml-auto mr-auto">
                            {{t('enter-security-code-to-access')}}
                        </p>
                    </div>
                    <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('security-code')}}
                            </label>
                            <mat-form-field>
                                <mat-label>{{t('enter-security-code')}}</mat-label>
                                <input matInput type="text" id="token" formControlName="token"/>
                            </mat-form-field>
                            <div class="error text-danger" *ngIf="authForm.get('token')!.hasError('required') &&authForm.get('token')!.touched">
                                {{t('security-code-is-required')}}
                            </div>
                            <div class="error text-danger" *ngIf="authForm.get('token')!.hasError('minlength') &&authForm.get('token')!.touched">
                                {{t('security-code-min-length')}}
                            </div>
                            <div class="error text-danger" *ngIf="authForm.get('token')!.hasError('maxlength') &&authForm.get('token')!.touched">
                                {{t('security-code-max-length')}}
                            </div>
                        </div>
                            <button
                                mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                                {{t('validate-security-code')}}
                            </button>
                        <div class="error text-danger" *ngIf="showAlert">
                            {{t('invalid-security-code')}}
                        </div>
                        <div class="text-center back-to-sign-in">
                            <a mat-button routerLink="/authentication/sign-in">
                                <i class="ri-arrow-left-s-line"></i>
                                {{t('back-to')}} {{t('sign-in')}}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-container>
